var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(["", ""], ["", ""]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import { css } from "styled-components";
import { defaultTheme } from "./index";

// DEPRECATE SOON:
var breakpointsOld = {
  phone: 0 / 16,
  tablet: defaultTheme.breakpointsRaw[0] / 16,
  desktop: defaultTheme.breakpointsRaw[1] / 16,
  wide: defaultTheme.breakpointsRaw[2] / 16,
  infinity: Number.POSITIVE_INFINITY
};

export var mediaProp = function mediaProp(propName, style) {
  return function (props) {
    var v = props[propName];
    var mediaStyler = media[v];
    if (mediaStyler) return mediaStyler(_templateObject, style);else if (v) return css(["", ";"], style);
  };
};

// DEPRECATE SOON:
var mediaOld = Object.keys(breakpointsOld).reduce(function (acc, label) {
  acc[label] = function () {
    return css(["@media (min-width:", "em){", ";}"], breakpointsOld[label], css.apply(undefined, arguments));
  };
  return acc;
}, {});

export var media = _extends({}, mediaOld, {

  // NEW:
  only: {
    // Device based on input mechanism:
    computer: function computer(style) {
      return css(["@media (hover:hover) and (pointer:fine){", "}"], style);
    },
    touchdevice: function touchdevice(style) {
      return css(["@media (hover:none) and (pointer:coarse){", "}"], style);
    },
    stylus: function stylus(style) {
      return css(["@media (hover:none) and (pointer:fine){", "}"], style);
    },
    // Resolution:
    retina: function retina(style) {
      return css(["@media (-webkit-min-device-pixel-ratio:2),(min-resolution:192dpi){", "}"], style);
    },
    // Device based on screen width:
    phone: function phone(style) {
      return css(["@media screen and (max-width:", "){", "}"], function (props) {
        return props.theme.breakpointsRaw[0] - 1 + "px";
      }, style);
    },
    tablet: function tablet(style) {
      return css(["@media screen and (min-width:", ") and (max-width:", "){", "}"], function (props) {
        return props.theme.breakpointsRaw[0] + "px";
      }, function (props) {
        return props.theme.breakpointsRaw[1] - 1 + "px";
      }, style);
    },
    desktop: function desktop(style) {
      return css(["@media screen and (min-width:", ") and (max-width:", "){", "}"], function (props) {
        return props.theme.breakpointsRaw[1] + "px";
      }, function (props) {
        return props.theme.breakpointsRaw[2] - 1 + "px";
      }, style);
    },
    wide: function wide(style) {
      return css(["@media screen and (min-width:", "){", "}"], function (props) {
        return props.theme.breakpointsRaw[2] + "px";
      }, style);
    }
  },
  up: {
    phone: function phone(style) {
      return css(["", ""], style);
    },
    tablet: function tablet(style) {
      return css(["@media screen and (min-width:", "){", "}"], function (props) {
        return props.theme.breakpointsRaw[0] + "px";
      }, style);
    },
    desktop: function desktop(style) {
      return css(["@media screen and (min-width:", "){", "}"], function (props) {
        return props.theme.breakpointsRaw[1] + "px";
      }, style);
    },
    wide: function wide(style) {
      return css(["@media screen and (min-width:", "){", "}"], function (props) {
        return props.theme.breakpointsRaw[2] + "px";
      }, style);
    }
  },
  down: {
    phone: function phone(style) {
      return css(["@media screen and (max-width:", "){", "}"], function (props) {
        return props.theme.breakpointsRaw[0] - 1 + "px";
      }, style);
    },
    tablet: function tablet(style) {
      return css(["@media screen and (max-width:", "){", "}"], function (props) {
        return props.theme.breakpointsRaw[1] - 1 + "px";
      }, style);
    },
    desktop: function desktop(style) {
      return css(["@media screen and (max-width:", "){", "}"], function (props) {
        return props.theme.breakpointsRaw[2] - 1 + "px";
      }, style);
    },
    wide: function wide(style) {
      return css(["", ""], style);
    }
  },
  supports: {
    hover: function hover(style) {
      return css(["@media (hover:hover){", "}"], style);
    }
  }
});